<template>
  <div class="ad">
    <h3>{{ item.title }}</h3>
    <time>{{
      moment(item.datetime.toDate()).format("DD-MM-YYYY hh:mm:ss A")
    }}</time>
    <div style="position: relative;width:100%;padding-top:100%;overflow:hidden">
        <img :src="item.image" style="width: 100%; position: absolute; top: 0; left: 0; object-fit:cover; height:100%" class="my-2" />
    </div>
    <small class="d-block inline-desc">
      {{ item.description }}
    </small>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: ["item"],
  methods: {
    moment,
  },
};
</script>

<style>
</style>